<template>
  <div class="container">
    <div class="nav-item" data-url="/parents/setting/parentinfo/" @click="pageNav">
      <div class="nav-name">家长资料</div>
      <van-icon class="nav-icon" name="arrow" color="#999" />
    </div>
    <div class="nav-item" data-url="/parents/setting/shippingaddress/" @click="pageNav">
      <div class="nav-name">收货地址</div>
      <van-icon class="nav-icon" name="arrow" color="#999" />
    </div>
    <div class="nav-item" :data-url="`/entry/terminal/h5modifypassword/?redirect_uri=${redirect}`" @click="pageNav">
      <div class="nav-name">修改密码</div>
      <van-icon class="nav-icon" name="arrow" color="#999" />
    </div>
  </div>
</template>
<script>
import gateway from '@/_gateway.config'
export default {
  data () {
    return {
      redirect: ''
    }
  },
  mounted () {
    this.redirect = encodeURIComponent(window.location.href)
  },
  methods: {

    pageNav (e) {
      var url = e.currentTarget.dataset.url
      location.href = `${gateway.masterpage}${url}`
    }
  }
}
</script>
<style lang="scss" scoped>
  .container{
    min-height:100vh;
    background:white;
    padding:30px;
    .nav-item{
      display:flex;
      align-items: center;
      height:110px;
      .nav-name{
        flex:1;
        font-size: 32px;
        font-weight: 400;
        color: #333333;
        margin-left:25px;
      }
      .nav-icon{
        font-size: 40px;
      }
    }
  }
</style>
